import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from 'src/app/shared/services/base-api.service';
import { GeneralResponse } from 'src/app/shared/shared-data-models';
import { environment } from 'src/environments/environment';
import { AddRequestAttachmentDto, RequestAttachmentDto } from '../../data-models/workflow.data.models';

@Injectable({
  providedIn: 'root'
})
export class RequestAttachmentsDataService {

  private controllerUrl: string = `${environment.appConfig.adminGatewayServiceBaseUrl}/api/1/RequestAttatchments/`;

  constructor(
    private baseApi: BaseApiService<any>,
  ) { }

  get(requestId: string): Observable<GeneralResponse<RequestAttachmentDto[]>> {
    return this.baseApi.Get(`${this.controllerUrl}Get?requestId=${requestId}`);
  }
  add(requestAttachment: AddRequestAttachmentDto): Observable<GeneralResponse<boolean>> {   
    return this.baseApi.Post(`${this.controllerUrl}Add`, requestAttachment);
  }

  delete(requestId: string): Observable<GeneralResponse<boolean>> {
    return this.baseApi.Delete(`${this.controllerUrl}Delete?requestId=${requestId}`);
  } 
}
